module.exports = __webpack_public_path__ + "static/media/carlsberg-polska.72a46769.png";